import { FC, useContext } from 'react';
import { StepperIndicator } from '@vs-online-only-app/ui';
import { IntroModulesContext } from './IntroModulesContext';

const IntroModulesFooter: FC = () => {
  const { nrOfModules, currentModuleIndex, error } =
    useContext(IntroModulesContext);

  if (error) {
    return null;
  }
  return (
    <StepperIndicator
      nrOfSteps={nrOfModules}
      currentStepIndex={currentModuleIndex}
    />
  );
};

export default IntroModulesFooter;
